import { BookingStoreNamespace } from "../index";
import { getModulePluginStore } from "../../../../dt-plugins/module-plugins/store";

export const BookingModulePluginStore = getModulePluginStore('BOOKING_PLUGINS', {
  storeNamespace: 'BookingStore',
  plugins_section: 'Booking',
});
